import { BlockCard } from "src/modules/worksheet/components/WorksheetEditor/components/Editor";

const renderCardSubjective = (props: any) => {
    return <BlockCard {...props}>Subjective Block</BlockCard>;
};

export default renderCardSubjective;
